import { RefObject } from 'react'
import '../index.scss'

type TTagBase = { id: string; value: string }

interface Props<Tag extends TTagBase> {
    tags: Tag[]
    capacity: number
    placeholder: string
    onTagEnter: (tag: Tag) => void
    onTagEdit: (tag: Tag) => void
    renderTag: (
        tag: Tag,
        index: number,
        onTagEdit: (tag: Tag) => void
    ) => TChild
    inputDisabled?: boolean
}

const MultiTagInput = <Tag extends TTagBase>(
    props: Props<Tag> & { tagInputRef: RefObject<HTMLInputElement> }
) => {
    const {
        tags,
        renderTag,
        capacity = 10,
        placeholder,
        onTagEnter,
        onTagEdit,
        inputDisabled,
        tagInputRef,
    } = props

    function handleKeyDown(e: TKeyboardInput) {
        if (
            e.key !== 'Enter' &&
            e.key !== 'Tab' &&
            e.key !== ',' &&
            e.key !== ' ' &&
            e.key
        )
            return
        const target = e.target as HTMLInputElement
        const value = target.value
        if (!value.trim() || !value.includes('.')) return
        onTagEnter({ id: value, value: value } as Tag)
    }

    function onBlur() {
        const value = tagInputRef?.current?.value as string
        if (!value?.trim() || !value?.includes('.')) return
        onTagEnter({ id: value, value: value } as Tag)
    }

    const isInputEnabled =
        !inputDisabled && Object.values(tags).length < capacity

    return (
        <div className="multi-tag-input">
            <div className="tags">
                {tags.map((tag, index) => renderTag(tag, index, onTagEdit))}

                {
                    <div className="input">
                        <input
                            data-testid="tag-input"
                            type="text"
                            disabled={!isInputEnabled}
                            ref={tagInputRef}
                            placeholder={
                                Object.values(tags).length < 1
                                    ? placeholder
                                    : ''
                            }
                            onKeyDown={handleKeyDown}
                            onBlur={onBlur}
                        />
                    </div>
                }
            </div>
        </div>
    )
}

export default MultiTagInput
